import { render, staticRenderFns } from "./Limit2Type.vue?vue&type=template&id=ea27066c&scoped=true&"
import script from "./Limit2Type.vue?vue&type=script&lang=js&"
export * from "./Limit2Type.vue?vue&type=script&lang=js&"
import style0 from "./Limit2Type.vue?vue&type=style&index=0&id=ea27066c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea27066c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VRow})
